import { render } from "./IndexPage.vue?vue&type=template&id=fd148ffc&scoped=true"
import script from "./IndexPage.vue?vue&type=script&lang=js"
export * from "./IndexPage.vue?vue&type=script&lang=js"

import "./IndexPage.vue?vue&type=style&index=0&id=fd148ffc&scoped=true&lang=css"

import exportComponent from "C:\\Users\\feegor\\PycharmProjects\\menlor\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd148ffc"]])

export default __exports__